import { useFiltersStore } from "@/store";
import { FilterType, FilterTypeEnum } from "@/features/filters";

export const useApplyFilter = (filterType: FilterType, zonePrefix?: string) => {
  const filtersStore = useFiltersStore();
  const { applyPanelSelectedFilters, applyFilters, removePanelSelectedFilter } = filtersStore;

  const applyFilter = (filterKey: string, value: any) => {
    const fullKey = zonePrefix ? `${zonePrefix}.${filterKey}` : filterKey;
    const [zone, key] = fullKey.includes(".") ? fullKey.split(".") : ["default", fullKey];

    if (filterType === FilterTypeEnum.PANEL_FILTERS) {
      applyPanelSelectedFilters(zone, key, value);
    } else {
      applyFilters(zone, key, value);
    }
  };

  const removeFilter = (filterKey: string) => {
    const fullKey = zonePrefix ? `${zonePrefix}.${filterKey}` : filterKey;
    const [zone, key] = fullKey.includes(".") ? fullKey.split(".") : ["default", fullKey];

    if (filterType === FilterTypeEnum.PANEL_FILTERS) {
      removePanelSelectedFilter(zone, key);
    }
  };

  return {
    applyFilter,
    removeFilter
  };
};
